export default __webpack_public_path__ + "static/media/page.d73a594c.png";